<script setup lang="ts" generic="T">
  import { type HeaderRenderProps } from "@krainovsd/vue-ui";
  import { ref } from "vue";
  import PinFilled from "@/components/icons/PinFilled.vue";
  import PinOff from "@/components/icons/PinOff.vue";
  import { fixedColumns$ } from "../table.events";

  const isFixed = ref(false);

  const props = defineProps<HeaderRenderProps<T>>();
  fixedColumns$.useSubscribe((value) => {
    const columnId = props.context.column.columnDef.id;

    if (!columnId) {
      isFixed.value = false;
      return;
    }

    if (value.includes(columnId)) {
      isFixed.value = true;
    } else {
      isFixed.value = false;
    }
  });

  function toggleColumn() {
    const current = fixedColumns$.value;

    const columnId = props.context.column.columnDef.id;

    if (!columnId) return;

    if (current.includes(columnId)) {
      fixedColumns$.next(current.filter((c) => c !== columnId));
    } else {
      fixedColumns$.next([...current, columnId]);
    }
  }
</script>

<template>
  <div>
    <div :class="$style.base">
      <span class="ksd-table__header-cell-default-text">
        {{ props.context.column.columnDef.name }}
      </span>
      <PinFilled v-if="isFixed" @click="toggleColumn()" />
      <PinOff v-if="!isFixed" @click="toggleColumn()" />
    </div>
  </div>
</template>

<style lang="scss" module>
  .base {
    display: flex;
    align-items: center;
    gap: var(--ksd-padding);
  }
</style>
